
/* eslint-disable @typescript-eslint/camelcase */
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { prop, Vue } from "vue-class-component";
import { AccountController } from "@/app/ui/controllers/AccountController";
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";

class Props {
  data = prop<any>({
    default: [],
  });
  startDate = prop<string>({
    default: "",
  });
  endDate = prop<string>({
    default: "",
  });
}
export default class ModalDetailCashback extends Vue.with(Props) {
  get countryCode() {
    const code = AccountController.accountData?.countryCode;
    return code?.toUpperCase() ?? "ID";
  }

  get showModalDetailCashback() {
    return BalanceController.showModalDetailCashback;
  }
  setShowModalDetailCashback(val: boolean) {
    BalanceController.setShowModalDetailCashback(val);
  }

  formatPriceMin(val: number) {
    const currency = this.countryCode === "MY" ? "MYR" : "IDR";
    return formatPrice(val, "", currency);
  }

  formatPriceMax(val: number) {
    const item = this.data[val];
    const prefix = this.countryCode === "MY" ? "RM" : "Rp";
    const formatted = formatByCountry(Math.abs(item.max_balance), {
      type: "money",
      country: this.countryCode,
      prefix
    });
    const isLastIndex = this.data.length - 1 === val;
    if (isLastIndex) {
      return item.max_balance > 0
        ? formatted
        : formatByCountry(Math.abs(item.min_balance), {
            type: "money",
            country: this.countryCode,
            prefix: `${prefix}>`
          });
    }
    return formatted;
  }
}
